import React from 'react';
import type { EpicDetail } from '../../../../../../shared/types/epics';
import { SecurityFindings } from '../../../../components/epicDetail/SecurityFindings';
import { MigrationPanel } from '../stories/MigrationPanel';
import { PostDeployChecks } from '../../../../components/epicDetail/PostDeployChecks';
import { ParityCard } from '../../../../components/epicDetail/ParityCard';

const PRE_DEPLOY = new Set([
  'DEFINED', 'REQUIREMENTS_REVIEW', 'REQUIREMENTS_QUESTIONS', 'REQUIREMENTS_QUESTIONS_IN_PROGRESS',
  'REQUIREMENTS_REPLY_RECEIVED', 'REQUIREMENTS_ALIGNED', 'PLANNING', 'PLAN_QUESTIONS',
  'PLAN_QUESTIONS_IN_PROGRESS', 'PLAN_POSTED', 'BUILDING', 'IN_PROGRESS',
]);

export const QualityTab: React.FC<{
  epic: EpicDetail;
  epicId: string;
  onFindingsCount: (count: number) => void;
}> = ({ epic, epicId, onFindingsCount }) => (
  <div className="space-y-5">
    {PRE_DEPLOY.has(epic.state) && (
      <div data-testid="quality-explainer" className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
        <div className="font-medium text-slate-900">Nothing to show here yet</div>
        Quality results appear after the change is built and deployed: integration tests and the log
        review on DEV/TEST, security-scan findings, and (for migrations) the before/after parity proof.
        Until then, follow progress on the Progress tab.
      </div>
    )}
    <MigrationPanel epic={epic} />
    {/* FORGE-348: Parity Proof Before/After — self-renders only for epics that ran it. */}
    <ParityCard epicId={epicId} />
    {/* FORGE-407: integration tests + CloudWatch log review timeline — self-renders
        only for epics that reached the post-deploy phase. */}
    <PostDeployChecks epicId={epicId} />
    {/* S-series: security-scan findings dashboard — self-renders only when
        the repo has FINDING# rows (null otherwise). */}
    <SecurityFindings epicId={epicId} onCount={onFindingsCount} />
  </div>
);
